import React from 'react';
import { useCart } from '../context/CartContext';
import { Link } from 'react-router-dom';
import './CheckoutBar.css';

const CheckoutBar = () => {
  const { getTotalItems, getTotalPrice } = useCart();
  const totalItems = getTotalItems();
  const totalPrice = getTotalPrice();

  if (totalItems === 0) {
    return null;
  }

  return (
    <div className="checkout-bar">
      <div className="checkout-info">
        <span>{totalItems} item(s) in your cart</span>
        <span>Total: ₹{totalPrice.toFixed(2)}</span>
      </div>
      <Link to="/cart" className="checkout-button">
        Checkout
      </Link>
    </div>
  );
};

export default CheckoutBar;